export function stringParaEnum<ET, T>(enumObj: ET, str: keyof ET): T {
    return enumObj[str as string];
}
